import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-makepaymentmodal',
  templateUrl: './makepaymentmodal.component.html',
  styleUrls: ['./makepaymentmodal.component.css']
})
export class MakepaymentmodalComponent implements OnInit {
  card: any;
  amount: number;
  bank: any;
  password: any;
  view: any = '';
  mandate: any;
  wallet: any;
  account: any;
  contract_date: any;
  public banks = [
    {value: "1", display: "Guaranty Trust Bank"},
    {value: "2", display: "Zenith Bank"},
    {value: "3", display: "UBA"},
    {value: "4", display: "First Bank"},
    {value: "5", display: "Polaris Bank"}
  ];
  public wallets = [
    {value: "1", display: "GTB-09063786512"},
    {value: "2", display: "ZEN-09063789912"},
    {value: "3", display: "POL-07663786512"},
    {value: "4", display: "FIR-09063556512"},
    {value: "5", display: "UBA-19063786512"}
  ];
  public cards = [
    {value: "1", display: "Master-6512"},
    {value: "2", display: "Verve-9912"},
    {value: "3", display: "Visa-7890"},
  ];

  constructor() {
  }

  ngOnInit() {
  }

  back() {
    this.view = '';
  }

  makePayment() {
    this.view = 'payment_mode';
    //console.log(this.amount)
  }

  sendPayment() {
    //console.log(this.bank, this.password);
  }

  cardPayment() {
    //console.log(this.card, this.password);
  }

  remitaPayment() {
    //console.log(this.mandate);
  }

  walletPayment() {
    //console.log(this.wallet)
  }

  addWallet() {
    //console.log(this.wallet);
  }
}
